import React, { useEffect } from "react";
import { useReactiveVar } from "@apollo/client";
import { isTrialBlockedShow, isTrialEndedShow } from "../../../graphql/state";

const isEditingControl = (target: EventTarget | null) => {
  if (!(target instanceof HTMLElement)) return false;

  return Boolean(
    target.closest(
      "input, textarea, select, button, a[href], [contenteditable='true'], [role='button']",
    ),
  );
};

const isEditingShortcut = (event: KeyboardEvent) =>
  event.key === "Backspace" ||
  event.key === "Delete" ||
  ((event.ctrlKey || event.metaKey) && ["a", "c", "v", "x", "y", "z"].includes(event.key.toLowerCase()));

const BlockedOverlay = () => {
  const blocked = useReactiveVar(isTrialBlockedShow);

  useEffect(() => {
    if (!blocked) return;

    const blockKeys = (event: KeyboardEvent) => {
      const modal = document.getElementById("trialEndedModal");
      if (modal && event.target instanceof Node && modal.contains(event.target)) return;

      if (isEditingControl(event.target) || isEditingShortcut(event)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        isTrialEndedShow(true);
      }
    };

    window.addEventListener("keydown", blockKeys, true);
    return () => window.removeEventListener("keydown", blockKeys, true);
  }, [blocked]);

  if (!blocked) return null;

  return (
    <div
      onClick={() => isTrialEndedShow(true)}
      onMouseDown={(event) => event.preventDefault()}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2000,
        cursor: "not-allowed",
        background: "transparent",
        pointerEvents: "auto",
      }}
    />
  );
};

export default BlockedOverlay;
